import { render, staticRenderFns } from "./ExamPrepSubject.vue?vue&type=template&id=036bfffe"
import script from "./ExamPrepSubject.vue?vue&type=script&lang=js"
export * from "./ExamPrepSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports